/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/* Add to cart on the collection page */
$(document).on('click', '.Collection__AddToCart', function(e) {
  // Prevent default action
  e.preventDefault();
  // Add to cart form, button and item count variables
  var $addToCartBtn = $(this).find('.product-grid-title');
  var $variant_id = $(this).data('variant');
  // Ajax function
  $.ajax({
    type: 'post',                             
    url: '/cart/add.js',
    dataType: 'json',                               
    data: {
      "id": $variant_id,
      "quantity": 1
    },            
    success: function(){
      // Change button text on success
      $addToCartBtn.text('Added');
      setTimeout(function(){
        $addToCartBtn.text('Add To Bag');
      }, 1500);
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: $variant_id,
          quantity: 1
        }
      }));
    },                        
    error: function(){
      alert('Adding to cart failed');
    }                           
  });
});

/* Query selector ever script */
document.querySelectorEver = (function() {
  let loaded = false;
  const selectors = [];
  const registerSelector = (selector, __callback) => {
    if (!typeof __callback == 'function') throw new TypeError('could not execute wheneverExist: You need to pass a callback function as the second paramater');
    selectors.push([selector, __callback]);


    if (loaded) document.querySelectorAll(selector).forEach(element => __callback(element));
  };  


  const observer = new MutationObserver((mutationsList, observer) => {
    for(const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node instanceof Element) {
            for (const selectorEntry of selectors) {
              const [selector, __callback] = selectorEntry;
              const elements = (node.matches(selector) && [node]) || node.querySelectorAll(selector);
              if (elements) elements.forEach(element => __callback(element));
            }
          }
        });
      }
    }
  });


  window.addEventListener('DOMContentLoaded', _ => {
    loaded = true;
    for (const selectorEntry of selectors) document.querySelectorAll(selectorEntry[0]).forEach(element => selectorEntry[1](element));
    observer.observe(document.body, { childList: true, subtree: true });
  });

  return registerSelector;
})();

/* Changing review stars format */
document.querySelectorEver('.ProductMeta .okeReviews-reviewsSummary-ratingCount > span:first-child', el => {
  console.log(el.innerHTML); // This will log every existing element and whenever a new element is added it will log them to
  var reviewRating = el.innerHTML.split(' ')[0];
  el.innerHTML = '(' + reviewRating + ')';
  el.style.opacity = '1';
});

/* Updating subscription widget price */
window.addEventListener('load', function (event) {
  const swatchEl = document.querySelectorAll(".ProductForm__Variants input");
  let swatchIndex,
      swatchValue,
      selectEl;

  for (i=0;i<swatchEl.length;i++) {
    swatchEl[i].addEventListener('change', function(e){
      swatchIndex = this.dataset.optionIndex;
      swatchValue = this.value;
      selectEl = document.querySelector('select[name="id"]');
      selectEl.value = swatchValue;
      selectEl.dispatchEvent(new Event('change'));
    });
  }
}, false);

/* Update image on hover (collection list) */
$(document).on('mouseenter', '.CollectionItemBox', function() {
  var image = $(this).data('image');
  var container = $(this).parents('.collection-list-container').find('.collection-list-image img');
  if (image) {
    container.attr('src', image);
  }
});